@let isSubmitting =
  ecSg().plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
@let hasPartiallyAssignedPayrolls = hasPartiallyAssignedPayrollsSg();

<atn-ds-centered-overlay>
  <atn-ds-widget title="Payroll Allocation">
    <div actions>
      <i
        class="atn-icon atn-close atn-red"
        (click)="cancelClickHandler()"
      ></i>
    </div>

    <div class="atn-occupant-payrolls-modal">
      @for (payroll of payrollsSg(); track $index) {
        <div class="atn-occupant-payrolls-modal__row">
          <atn-ds-checkbox
            [selected]="payroll.assignment === Assignment.Full"
            [someSelected]="payroll.assignment === Assignment.Partial"
            (selectedChange)="payrollCheckboxChangedHandler($index, $event)"
          />
          <div
            class="atn-occupant-payrolls-modal__cell atn-occupant-payrolls-modal__cell--project"
          >
            <span>
              {{ payroll.project?.code }} - {{ payroll.project?.name }}
            </span>
            @if (payroll.assignment === Assignment.Partial) {
              <span
                class="atn-occupant-payrolls-modal__warning"
                role="img"
                aria-label="Corrupted data"
              >
                <atn-ds-notice-icon
                  [style]="DisplayStyle.Warning"
                  description="Corrupted data"
                />
              </span>
            }
          </div>
          <div class="atn-occupant-payrolls-modal__cell">
            {{ payroll.organization.name }}
          </div>
          <div class="atn-occupant-payrolls-modal__cell">
            {{ payrollAllocation(payroll) }}
          </div>
        </div>
      } @empty {
        <div class="atn-occupant-payrolls-modal__empty-state">
          No payrolls available for this occupant
        </div>
      }

      @if (hasPartiallyAssignedPayrolls) {
        <div class="atn-occupant-payrolls-modal__notice">
          <atn-ds-notice
            [style]="DisplayStyle.Warning"
            description="Some payrolls are only partly assigned. Before saving, click each one marked with a warning to assign all of its entries, or click it again to assign none."
          />
        </div>
      }
    </div>

    <div
      class="atn-occupant-payrolls-modal__footer"
      footer
    >
      <atn-ds-button
        type="transparent"
        (click)="cancelClickHandler()"
      >
        Cancel
      </atn-ds-button>
      <atn-ds-button
        (click)="saveClickHandler()"
        [disabled]="hasPartiallyAssignedPayrolls"
        [loading]="isSubmitting"
      >
        Save
      </atn-ds-button>
    </div>
  </atn-ds-widget>
</atn-ds-centered-overlay>
